module.exports = __webpack_public_path__ + "img/Skill-Profiles.8e7f342c.svg";